import { formatCityString } from "@faire/retailer-visitor-shared/lib/formatCityString";
import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web--source/common/consts/ISO_TO_COUNTRY_NAME";
import { STATE_PROVINCE_SHORTHAND_TO_NAME } from "@faire/web--source/common/consts/STATE_PROVINCE_SHORTHAND_TO_NAME";
import startCase from "lodash/startCase";
export var getBrandLocationString = function(input, strictLocalize) {
    var city = formatCityString(input.city);
    var _input_state, // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    _STATE_PROVINCE_SHORTHAND_TO_NAME_;
    var state = startCase((_STATE_PROVINCE_SHORTHAND_TO_NAME_ = STATE_PROVINCE_SHORTHAND_TO_NAME(strictLocalize)[(_input_state = input.state) !== null && _input_state !== void 0 ? _input_state : ""]) !== null && _STATE_PROVINCE_SHORTHAND_TO_NAME_ !== void 0 ? _STATE_PROVINCE_SHORTHAND_TO_NAME_ : input.state);
    var country = input.country ? ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize)[input.country] : undefined;
    if (city && state) {
        return input.addBasedIn ? strictLocalize({
            id: "06Bv6e",
            defaultMessage: [
                {
                    type: 0,
                    value: "Based in "
                },
                {
                    type: 1,
                    value: "CityAddress"
                },
                {
                    type: 0,
                    value: ", "
                },
                {
                    type: 1,
                    value: "StateAddress"
                }
            ]
        }, {
            CityAddress: city,
            StateAddress: state
        }) : strictLocalize({
            id: "nAOCCt",
            defaultMessage: [
                {
                    type: 1,
                    value: "CityAddress"
                },
                {
                    type: 0,
                    value: ", "
                },
                {
                    type: 1,
                    value: "StateAddress"
                }
            ]
        }, {
            CityAddress: city,
            StateAddress: state
        });
    }
    if (city || state) {
        return input.addBasedIn ? strictLocalize({
            id: "VbtHVU",
            defaultMessage: [
                {
                    type: 0,
                    value: "Based in "
                },
                {
                    type: 1,
                    value: "CityOrStateAddress"
                }
            ]
        }, {
            CityOrStateAddress: city || state
        }) : city || state;
    }
    if (country) {
        return input.addBasedIn ? strictLocalize({
            id: "M8/flS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Based in "
                },
                {
                    type: 1,
                    value: "CountryAddress"
                }
            ]
        }, {
            CountryAddress: country
        }) : strictLocalize({
            id: "J1zCTq",
            defaultMessage: [
                {
                    type: 1,
                    value: "CountryAddress"
                }
            ]
        }, {
            CountryAddress: country
        });
    }
    return undefined;
};
